import React, { HTMLAttributes } from 'react';
import Immutable from 'immutable';

import {
  Paragraph,
} from '@uncinc/react-drupal-core';

import {
  WysiwygField,
} from '@uncinc/uncinc-react-kitchen-sink';

import useClasses from '../../../hooks/useClasses';
import { ImmutableGenericNodeEntity } from '..';

import './style.scss';
import { Main } from '../../../components';

interface Props extends React.HTMLProps<HTMLAttributes<HTMLDivElement>> {
  entity: ImmutableGenericNodeEntity;
}

const NodeHelp: React.FC<Props> = ({ entity }) => {
  const { buildClass, joinClasses } = useClasses('NodeHelp');

  const title = entity.getIn(['title', 0, 'value'], '');
  const body = entity.getIn(['body', 0, 'processed'], '');
  const paragraphs = entity.get('field_paragraphs', Immutable.List());
  const heroImage = entity.getIn(['field_media_item', 0, 'entity', 'field_media_file', 0], Immutable.Map());

  return (
    <Main className={joinClasses(buildClass(), 'col-lg-10 py-8 py-lg-12')}>
      <article>
        <div className="row">
          {heroImage && (
            <div className="col-md-4 order-md-2">
              <div className={buildClass('hero-image')}>
                <img src={heroImage.get('url')} alt={heroImage.get('description')} />
              </div>
            </div>
          )}

          <div className="col-md-8 order-md-1">
            <div className={buildClass('title')}>
              <h1>{title}</h1>
            </div>

            {body.length > 0 && (
              <div className={buildClass('body')}>
                <WysiwygField
                  property="schema:text"
                  html={body}
                />
              </div>
            )}
          </div>

          <div className="col-12 order-3">
            {paragraphs.size > 0 && (
              <div className={buildClass('paragraphs')}>
                {paragraphs.map((paragraph) => {
                  const id: number = paragraph.get('target_id');
                  const language = paragraph.getIn(['entity', 'langcode', 0, 'value']);
                  return (
                    <Paragraph
                      key={`paragraph:${id}:${language}`}
                      id={id}
                      entity={paragraph.get('entity')}
                    />
                  );
                })}
              </div>
            )}
          </div>
        </div>
      </article>
    </Main>
  );
};

export default NodeHelp;
